<template>
  <app-image
    alt="Pollen logo"
    class="desktop-nav:w-[170px] w-[125px]"
    loading="eager"
    :src="light ? '/images/logo_full_white.svg' : '/images/logo_full_color.svg'"
    :width="170"
  />
</template>

<script lang="ts" setup>
defineProps<{
  light?: boolean;
}>();
</script>
